import { post } from 'axios';
import API from '../../settings/api';
//// import cookie from 'react-cookies';

export async function get( store, id ) {

  try {

    const { status, data } = await post( API.windows.get, { id } );
    if ( status !== 200 || !data?.success || !data?.windows ) {
      throw( data?.text || `Не удалось открыть схему с ID ${ id }` );
    }

    const windows = data.windows;

    store.setState({

      windows_id: windows.id,
      windows_schema: Array.isArray( windows.shema ) ? windows.shema : [],
      windows_height: windows.height || 0,
      windows_area_sizes: Array.isArray( windows.area_sizes ) ? windows.area_sizes : [],
      windows_schema_inner: Array.isArray( windows.shema_inner ) ? windows.shema_inner : [],
      windows_contract: windows.contract,
      windows_insulation: windows.insulation,
      windows_profile: windows.profile,
      windows_count_cameras: windows.count_cameras,
      windows_glazing: windows.glazing,
      windows_profile_color: windows.profile_color || {},
      windows_mosquitos_count: windows.mosquitos_count,
      windows_visor: windows.visor || {},
      windows_nachelnik: windows.nachelnik || {},
      windows_lowtide: windows.lowtide || {},
      windows_comment: windows.comment || '',
      windows_inner_glazing: windows.glazing_inner,
      windows_inner_insulation: windows.insulation_inner,
      windows_inner_count_cameras: windows.count_cameras_inner,
      windows_inner_profile: windows.profile_inner,
      windows_inner_profile_color: windows.profile_color_inner || {},

    });

    return true;

  } catch ( err ) {

    console.error( err );
    return false;

  }
  
}

export function renderPartSize({ windows_schema, windows_area_sizes }) {

  const splitterType = 4;
  const windowImageSize = 82;

  if ( windows_schema.length === 0 ) {

    return [ { space: '100%' } ];

  }

  let j = 0;
  let result = [];

  for ( let i = 0; i < windows_schema.length; i++ ) {

    if ( windows_schema[ i ].type === splitterType ) {

      j += 1;

    } else {

      if ( !result[ j ] ) { result[ j ] = { space: 0, size: 0 } }

      result[ j ].space += windowImageSize

      if ( windows_area_sizes?.[ j ] ) {

        result[ j ].size = windows_area_sizes[ j ];

      }

    }

  }

  // console.log(`renderPartSize result = `, result );

  return result;

}

export async function changePartSize( store, index, size ) {

  try {

    let arr = store.state.windows_area_sizes;
    //// debug: 
    ////console.log(`changePartSize( ${ index}, ${size} ) arr before = ${ JSON.stringify( arr )} (original=)`,arr);
    arr[ index ] = size;
    //// debug: 
    ////console.log(`changePartSize( ${ index}, ${size} ) arr after = ${ JSON.stringify( arr )} (original=)`,arr);

    store.setState({ windows_area_sizes: arr });

    store.actions.smeta.calculateSmeta();

  } catch ( err ) {



  }

}